import React from 'react';
import { motion } from 'framer-motion';

interface ProjectsHeroSectionProps {
  language?: 'ar' | 'en';
  titleAr?: string;
  titleEn?: string;
  subtitleAr?: string;
  subtitleEn?: string;
}

const ProjectsHeroSection: React.FC<ProjectsHeroSectionProps> = ({
  language = 'ar',
  titleAr = 'مشاريعنا المنجزة',
  titleEn = 'Our Completed Projects',
  subtitleAr = 'اكتشف مجموعة من مشاريعنا المنجزة بنجاح في مجال المقاولات والمحاجر والتعدين، والتي تعكس خبرتنا الواسعة والتزامنا بالجودة العالية',
  subtitleEn = 'Discover a collection of our successfully completed projects in construction, quarrying, and mining, reflecting our extensive experience and commitment to high quality'
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="relative bg-gradient-to-br from-primary-900 via-primary-800 to-secondary-900 py-20">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center text-white"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            {isRTL ? titleAr : titleEn}
            <span className="text-secondary-400"> {isRTL ? 'المنجزة' : 'Completed'}</span>
          </h1>
          <p className="text-xl text-primary-100 max-w-3xl mx-auto">
            {isRTL ? subtitleAr : subtitleEn}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProjectsHeroSection; 